/**
 * PageSection composite component exports
 *
 * Exports the PageSection component, its props interface, variant function,
 * and variant props type for use throughout the application.
 */
export { PageSection, type PageSectionProps } from './PageSection';
export {
  pageSectionVariants,
  type PageSectionVariantProps,
} from './pageSection.variants';
